/**
 *  Duck for scrolling to a specific element
 *
 * Action Types:
 * - SCROLL_TO_ELEMENT
 *
 * Action Creators:
 * - scrollToElement
 */

import type { ScrollToElement } from '../types';

/** @type {ActionType} */
export const SCROLL_TO_ELEMENT = 'PB/scrollPosition/SCROLL_TO_ELEMENT';
export const UPDATE_SCROLL_POSITION =
  'PB/scrollPosition/UPDATE_SCROLL_POSITION';

export function scrollToElement(
  elementId: string,
  yOffset: number = 0,
): ScrollToElement {
  return {
    type: SCROLL_TO_ELEMENT,
    payload: { elementId, yOffset },
  };
}

export function updateScrollPosition(url: string, router: any) {
  return {
    type: UPDATE_SCROLL_POSITION,
    payload: { url, router },
  };
}
